import { createContext } from "react";
import { UserSettings } from "./types";

export interface SettingsContextValue {
  // Current settings from Firestore (null if not logged in or not yet loaded)
  settings: UserSettings | null;

  // Loading state
  loading: boolean;

  // Manually trigger a sync to Firestore (usually automatic via Redux listener)
  syncToFirestore: () => Promise<void>;

  // Load settings from Firestore and merge with current Redux state
  // Returns the loaded settings, or null if not found, or undefined on error
  loadFromFirestore: () => Promise<UserSettings | null | undefined>;
}

export const SettingsContext = createContext<SettingsContextValue | undefined>(
  undefined
);
